import { useState } from 'react';
import { downloadBase64AsPDF } from '@ibk/shared-utils';
import { useGenerateRechargeReportPdfMutation, } from '../services/contractRechargeReportApi';
function resolveErrorCode(error) {
    const candidate = error;
    return candidate?.details?.result?.code ?? candidate?.data?.result?.code;
}
export function useEmissorRechargeReportPdf() {
    const [trigger] = useGenerateRechargeReportPdfMutation();
    const [isLoading, setIsLoading] = useState(false);
    async function fetchReport(params, filename) {
        setIsLoading(true);
        try {
            const base64 = await trigger(params).unwrap();
            if (!base64) {
                return { status: 'failure' };
            }
            downloadBase64AsPDF(base64, filename);
            return { status: 'success' };
        }
        catch (error) {
            return { status: 'failure', code: resolveErrorCode(error) };
        }
        finally {
            setIsLoading(false);
        }
    }
    return { isLoading, fetchReport };
}
